import { BlockUi } from './../../auth/_helpers/block-ui';
import { PetsService } from 'src/app/auth/_services/pets.service';
import { Pet } from './../../auth/_models/pet';
import { StorageService } from './../../auth/_services/storage.service';
import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

declare let $: any;
declare let CustomScript: any;

@Component({
  selector: 'app-my-pet',
  templateUrl: './my-pet.component.html',
  styleUrls: ['./my-pet.component.css'],
  providers: [StorageService, PetsService]
})
export class MyPetComponent implements OnInit, AfterViewInit {

  public originalCoverPhoto = null;
  public newCoverPhoto = null;

  pet: Pet;

  constructor(
    private _storageService: StorageService,
    private _route: ActivatedRoute,
    private _service: PetsService,
    private _blockui: BlockUi,
  ) { }

  ngOnInit() {

    this._route.params.subscribe(params => {
      const uuid = params['id'];
      this._service
        .getPet(uuid)
        .valueChanges()
        .subscribe(p => {

          p.uuid = uuid;

          if (p.birthday) {
            if (typeof p.birthday.toDate === 'function') {
              p.birthday = p.birthday.toDate();
            }
          }

          if (p.coverPhoto && p.coverPhoto !== '') {
            const pathReference = `pets/${p.uuid}/` + p.coverPhoto;

            this._storageService.getPhotoUrl(pathReference).then(url => {
              // console.log();
              $('.profile-cover-img').css('background-image', 'url(' + url + ')');
            });

          } else {
            $('.profile-cover-img').css('background-image', 'url(./assets/images/defult-cover.png)');
          }

          this.pet = p;
        });
    });

  }

  ngAfterViewInit(): void {
    CustomScript.initUniform();
  }

  chooseFile(event) {
    const that = this;

    this.newCoverPhoto = event.target.files[0];

    if (this.newCoverPhoto) {
      console.log('Arquivo selecionado: ', this.newCoverPhoto);

      const reader = new FileReader();

      reader.onload = function (e) {

        that.originalCoverPhoto = $('.profile-cover-img').css('background-image');
        $('.profile-cover-img').css('background-image', 'url(' + e.target['result'] + ')');

        // $('.profile-cover-img').addClass('image-cropper-container');
        // $('.profile-cover-img-src').attr('src', e.target['result']);
        // $('.profile-cover-img-src').cropper({
        //   dragMode: 'move',
        //   autoCrop: false,
        //   movable: true,
        //   cropBoxMovable: false,
        //   cropBoxResizable: false,
        //   aspectRatio: 1603 / 350
        // });
        // $('.cropper').cropper('clear');
      };

      reader.readAsDataURL(this.newCoverPhoto);
    }
  }

  confirmChangeCover() {

    if (this.newCoverPhoto) {

      const photoUuid = `cover${this.pet.uuid}${this.getHashDate()}.png`;
      const path = `pets/${this.pet.uuid}/` + photoUuid;

      /** Trava a interface */
      this._blockui.block();

      this._storageService
        .uploadPhoto(path, this.newCoverPhoto)
        .on('state_changed',
          (snapshot: firebase.storage.UploadTaskSnapshot) => {

            console.log('Progress: ' + Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100) + '%');
            // this.user.photoURL = snapshot.downloadURL;

          },
          (error) => {

            console.error('Falha ao realizar upload do arquivo: ' + error);
            this._blockui.unblock();

          },
          () => {

            console.log('Upload finalizado!');
            this.updateCoverPhoto(photoUuid);
            this.cancelChangeCover();
            this._blockui.unblock();

          });

      this.newCoverPhoto = null;
    }
  }

  cancelChangeCover() {
    this.newCoverPhoto = null;
    $('.profile-cover-img').css('background-image', this.originalCoverPhoto);
    $('.change-cover').hide();
  }

  openChangeCover() {
    this.newCoverPhoto = null;
    $('.change-cover').show();
  }

  updateCoverPhoto(photoName: string) {

    const _pet: any = {
      uuid: this.pet.uuid,
      coverPhoto: photoName
    };

    this._service
      .updatePetObj(_pet, _pet.uuid)
      .then((data) => {
        console.log('atualizado');
      })
      .catch((err) => {
        console.error('não atualizou');
      });

  }

  getHashDate() {

    const date = new Date(),
      day = date.getDate().toString(),
      dayF = (day.length === 1) ? '0' + day : day,
      mou = (date.getMonth() + 1).toString(),
      mouF = (mou.length === 1) ? '0' + mou : mou,
      year = date.getFullYear().toString(),
      hour = date.getHours().toString(),
      hourF = (hour.length === 1) ? '0' + hour : hour,
      min = date.getMinutes().toString(),
      minF = (min.length === 1) ? '0' + min : min,
      sec = date.getSeconds().toString(),
      secF = (sec.length === 1) ? '0' + sec : sec;

    return year + mouF + dayF + hourF + minF + secF;

  }
}
